import React from "react";
import './TrackList.css';
import Track from "../Track/Track";

const TrackList = ({ tracks, onAdd, onRemove, isRemoval }) => {
    return (
        <div className="TrackList">
           { tracks?.map(track => {
               return <Track track={track} 
               key={track.id} 
               isRemoval={isRemoval} 
               onAdd={onAdd} 
               onRemove={onRemove} />
            })}
        </div>
    );
};

export default TrackList;
